import { useCallback, useEffect, useMemo, useState } from 'react';

import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { fetchNudgeRecommendations } from '../utils/fetchNudgeRecommendations';

type useFetchNudgeRecommendationsReturnType = {
	error?: Error;
	loading: boolean;
	recommendations: NudgeRecommendationDetails | undefined;
};

export const useFetchNudgeRecommendations = (
	triggerId: string,
	pageUrl: string,
	product: string,
): useFetchNudgeRecommendationsReturnType => {
	const [error, setError] = useState<Error | undefined>(undefined);
	const [loading, setLoading] = useState(true);
	const [recommendations, setRecommendations] = useState<NudgeRecommendationDetails | undefined>(
		undefined,
	);

	const makeNudgeRecommentaionsRequest = useCallback(async () => {
		if (!product) {
			setLoading(false);
			return;
		}
		try {
			const response = await fetchNudgeRecommendations({ triggerId, pageUrl, product });
			setRecommendations(response?.triggers[0].recommendations[0].recommendation_details);
		} catch (error: unknown) {
			setError(error as Error);
		} finally {
			setLoading(false);
		}
	}, [triggerId, pageUrl, product]);

	useEffect(() => {
		void makeNudgeRecommentaionsRequest();
	}, [makeNudgeRecommentaionsRequest]);

	return useMemo(
		() => ({
			recommendations: loading ? undefined : recommendations,
			loading,
			error,
		}),
		[loading, error, recommendations],
	);
};
